import {Component, OnInit, HostListener, Inject} from '@angular/core';

@Component({
    selector: 'app-pp',
    templateUrl: './pp.component.html'
})
export class PpComponent implements OnInit {
    constructor() {
    }

    year = new Date().getFullYear();
    ngOnInit() {
    }

}
